<template>
  <section id="future">
    <h1>what I'm looking for</h1>
    <div class="section-description">
      <p>
        A team to lead on a company I can help grow!
      </p>
      <p class="no-print">
        My future company should be a place where <b>learning</b> and sharing knowledge is <b>actively encouraged</b>. I feel specially motivated in projects where we can collaborate into creating <b>delightful user experiences</b> for great products.
      </p>
      <p class="no-print">
        Other features that thrive me are an <b>open-minded culture</b>, flexibility, a healthy environment, a focused team and companies where technology is nourished from its heart.
      </p>
      <ul
        class="print-only"
        style="list-style: inside '—'"
      >
        Where...
        <li>
          sharing and learning is encouraged,
        </li>
        <li>
          there's a clear focus on customer experience,
        </li>
        <li>
          and technology and their people is at heart.
        </li>
        <small>(full redaction at website)</small>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Future'
}
</script>
